import { render, staticRenderFns } from "./ShortlinkEdit.vue?vue&type=template&id=506acbd2&scoped=true"
import script from "./ShortlinkEdit.vue?vue&type=script&lang=js"
export * from "./ShortlinkEdit.vue?vue&type=script&lang=js"
import style0 from "./ShortlinkEdit.vue?vue&type=style&index=0&id=506acbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506acbd2",
  null
  
)

export default component.exports